import React, { useEffect, useState } from 'react';
import { GameInterface } from '../constants/GameInterface';
import { Dialogs } from '../constants/Dialogs';
import { Stats } from '../classes/Stats';
import { getCriminalImageSubPath } from '../utils/AvatarUtils';
import { getBlackCardText, getRedCardText } from '../utils/TextsUtils';
import { useNavigate } from "react-router-dom";

function KeyMomentsDialog({dialog, setDialog, isHost, setIsHost, gameId, setGameId, playerId, setPlayerId, isLate, setIsLate, statsId, setStatsId, keyMoments, setKeyMoments, players, setPlayers, scoresMap, setScoresMap}: GameInterface) {
    const navigate = useNavigate();
    const [keyMomentIndex, setKeyMomentIndex] = useState(0);

    const subPath = getCriminalImageSubPath(keyMoments[keyMomentIndex].criminalGender)
    const playerImage = require("../images/" + subPath + "/" + keyMoments[keyMomentIndex].criminalImage + ".png");
    
    const leftArrowIcon = require("../images/whiteLeftArrow.png");
    const rightArrowIcon = require("../images/whiteRightArrow.png");

    const goHome = () => {
        navigate("/");
    }

    const handleLeftClick = () => {
        setKeyMomentIndex(keyMomentIndex - 1);
        Stats.updateKeyMomentsViewCount(statsId);
    }

    const handleRightClick = () => {
        setKeyMomentIndex(keyMomentIndex + 1);
        Stats.updateKeyMomentsViewCount(statsId);
    }

    useEffect(() => {
        Stats.updateKeyMomentsViewCount(statsId);
    }, [])

    return (
        <div className="overallWrapper">
            <div className="keyMomentsWrapper">
                <img className="keyMomentsCriminalImage" src={playerImage} alt="red card receiver"/>
                <div className="keyMomentsArrowsWrapper">
                    {keyMomentIndex > 0 ? <div className="keyMomentsLeftArrow" tabIndex={0} onClick={handleLeftClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleLeftClick();
                    }
                }}>
                        <img className="keyMomentsLeftArrowIcon" src={leftArrowIcon} alt="left arrow"/>
                    </div> : <div/>}
                    {keyMomentIndex < keyMoments.length - 1 ? <div className="keyMomentsRightArrow" tabIndex={0} onClick={handleRightClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleRightClick();
                    }
                }}>
                        <img className="keyMomentsRightArrowIcon" src={rightArrowIcon} alt="right arrow"/>
                    </div> : <div/>}
                </div>
                <div className="keyMomentsContentOuterWrapper">
                    <div className="keyMomentsContentInnerWrapper">
                        <div className="keyMomentsCrimeText">
                            {getRedCardText(keyMoments[keyMomentIndex].redCardIdx, keyMoments[keyMomentIndex].criminalName, keyMoments[keyMomentIndex].criminalGender)}
                        </div>
                        <div className="keyMomentsKarmaText">
                            {"KARMA: " + getBlackCardText(keyMoments[keyMomentIndex].winningBlackCardIdx, keyMoments[keyMomentIndex].criminalName, keyMoments[keyMomentIndex].criminalGender)}
                        </div>
                        <div className="keyMomentsSubmittedByText">
                            {"Submitted by " + keyMoments[keyMomentIndex].winnerName}
                        </div>
                    </div>
                    <button className="keyMomentsHomeButton" onClick={goHome}>HOME</button>
                </div>
            </div>
        </div>
    );
};

export default KeyMomentsDialog;